import { ChevronRight, Clock, Person } from "react-bootstrap-icons";
import { getAuthors, getTimePeriod, IWebinar } from "../../utils/webinar";
import "./webinarItem.css"

interface Props {
    webinar: IWebinar;
    index?: number;
    interactive?: boolean;
}

export default function WebinarItem({ webinar, index = 0, interactive = false }: Props) {
    const start = new Date(webinar.start_date);
    const authors = getAuthors(webinar.json_data);

    return (
        <article className={`webinar-item${interactive ? " interactive" : ""}`}>
            <div className="webinar-date">
                <span className="day">{String(start.getDate()).padStart(2, "0")}</span>
                <span className="month">{start.toLocaleDateString("it-IT", { month: "short" })}</span>
                <span className="year">{start.getFullYear()}</span>
            </div>
            <div className="webinar-body">
                {/* {index !== 0 && <span className="webinar-index">Webinar {index}</span>} */}
                <h3>{webinar.title}</h3>
                {webinar.subtitle && <p className="webinar-subtitle">{webinar.subtitle}</p>}
                <div className="webinar-meta">
                    <span><Clock /> {getTimePeriod(webinar.start_date, webinar.end_date)}</span>
                    {authors && <span><Person /> {authors}</span>}
                </div>
            </div>
            {interactive && <ChevronRight className="webinar-arrow" />}
        </article>
    )
}
